<template>
    <div>
        <h2>Choose your plan</h2>

        <p>IDX search is included with every plan. Add the Website Builder to also get a full agent website.</p>

        <div class="signup-form__field">
            <span class="signup-form__label">Plan</span>

            <label class="signup-choice">
                <input
                    type="radio"
                    class="signup-choice__control"
                    name="planTier"
                    value="idx_only"
                    :checked="!isWebsiteBuilder"
                    @change="setTier('idx_only')"
                />
                <span class="signup-choice__label">
                    IDX Only
                    <small class="signup-choice__meta" v-if="idxBase">— ${{ formatPrice(idxBase.basePrice) }}/mo</small>
                </span>
            </label>

            <label class="signup-choice">
                <input
                    type="radio"
                    class="signup-choice__control"
                    name="planTier"
                    value="idx_plus_wb"
                    :checked="isWebsiteBuilder"
                    @change="setTier('idx_plus_wb')"
                />
                <span class="signup-choice__label">
                    IDX + Website Builder
                    <small class="signup-choice__meta" v-if="idxBase && wbAddon">
                        — ${{ formatPrice(parseFloat(idxBase.basePrice) + parseFloat(wbAddon.basePrice)) }}/mo
                    </small>
                </span>
            </label>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import useState from '@/composables/useState';

const { state, toggleAddon } = useState();

const idxBase = computed(() => state.catalog.plans.find((p) => p.code === 'idx_base'));
const wbAddon = computed(() => state.catalog.addons.find((a) => a.code === 'website_builder'));

const isWebsiteBuilder = computed(() => state.form.addonCodes.includes('website_builder'));

const setTier = (tier) => {
    if (tier === 'idx_plus_wb' && !isWebsiteBuilder.value) {
        toggleAddon('website_builder');
    } else if (tier === 'idx_only' && isWebsiteBuilder.value) {
        toggleAddon('website_builder');
    }
};

const formatPrice = (n) => parseFloat(n).toFixed(2);
</script>
